import { FilterComponentTypes } from '../const';
import { SKEYS } from '../../../constants/storagekeys';

export const INITIAL_FILTER_STATE = {
  filterItems: [],
  sortItems: [],
  currentSortItem: null,
  currentFilterItems: [],
  currentTextBoxItems: [],
  currentTextBoxIsLoadingStates: [],
  isStateInitial: true,
};

export const LOCAL_STORAGE_KEYS = {
  [FilterComponentTypes.OrdersDashboard]: SKEYS.BBW_ORDERS_DASHBOARD_FILTERS_STATE,
  [FilterComponentTypes.ArchivedOrdersDashboard]: SKEYS.BBW_ARCHIVED_ORDERS_DASHBOARD_FILTERS_STATE,
  [FilterComponentTypes.OrderInfo]: SKEYS.BBW_ORDER_PAGE_FILTERS_STATE,

  [FilterComponentTypes.OrdersNew]: SKEYS.BBW_ORDERS_ROUTING_FILTERS_STATE,
  [FilterComponentTypes.ArchivedOrdersNew]: SKEYS.BBW_ARCHIVED_ORDERS_ROUTING_FILTERS_STATE,
  [FilterComponentTypes.OrdersNewInfo]: SKEYS.BBW_ORDER_ROUTING_INFO_FILTERS_STATE,
};
